import { render, staticRenderFns } from "./CookieView.vue?vue&type=template&id=273553ef&scoped=true&"
import script from "./CookieView.vue?vue&type=script&lang=js&"
export * from "./CookieView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273553ef",
  null
  
)

export default component.exports